<template>
  <div v-if="translate">
    <div
      v-if="
        (combinations[data.group] &&
          combinations[data.group].supplierCheck &&
          postcodeQuery) ||
          !combinations[data.group] ||
          (combinations[data.group] &&
            !combinations[data.group].supplierCheck) ||
          (combinations[data.group].supplierCheck && data.type === 'suppliers')
      "
    >
      <div
        v-if="
          data.group !== 'customerwidget' &&
            data.type !== 'customizedoffer' &&
            data.type !== 'detailedoffer'
        "
        :class="
          data.product
            ? 'block product' + data.product + ' ' + data.group
            : 'block ' + data.group
        "
      >
        <div>
          <div
            class="block-header block-header-default"
            v-if="
              data.type !== 'html' &&
                data.type !== 'datewidget' &&
                data.type !== 'familySituation' &&
                data.type !== 'cityheat' &&
                data.type !== 'water' &&
                data.type !== 'insuranceForLead'
            "
          >
            <h3 class="block-title" v-if="data.type !== 'products'">
              <small>{{
                data.subtitle === undefined
                  ? data.title
                  : translate[lang][data.subtitle[lang]]
              }}</small>
            </h3>
            <!-- <h3 class="block-title">{{ translate[lang][data.title] }}</h3> -->
            <h3 class="block-title" v-else>
              {{
                translate[lang][data.title] ||
                  data.title ||
                  translate[lang].productwidget
              }}
            </h3>
          </div>
          <div
            class="block-header block-header-default"
            v-else-if="!data.html.includes('<script')"
          >
            <h3
              v-if="data.type == 'familySituation' && customertype == 2"
              class="block-title"
            >
              {{
                translate[lang]["Business Situation"] || "Business Situation"
              }}
            </h3>
            <h3 v-else class="block-title">
              {{ translate[lang][data.title] || data.title }}
            </h3>
          </div>
        </div>
        <div class="block-content">
          <div v-if="data.type === 'html'">
            <widget-component
              :id="data.widgetCardId"
              :action="data.action"
              :html="data.html"
              :open="openModal"
            ></widget-component>
          </div>
          <!-- list of products -->
          <div v-if="data.type === 'products'" class="row">

            <div

              class="col-lg-3 col-md-4 col-sm-6 mb-3"
              v-for="item in products"
              :key="item.id"
              v-if="!removeProducts.includes(item.id)"
            >

              <div
                class="utility"
                :class="isDisabled(item) ? 'disabledProductsSelect' : ''"

              >
                <input
                  :id="item.id"
                  @change="selectProduct($event, item.id, data)"
                  :name="'products[' + item.group + '][id]'"
                  type="checkbox"
                  :value="item.id"
                  :checked="
                    data.defaultProducts.indexOf(item.id) >= 0 ? true : false
                  "
                  :disabled="isDisabled(item)"
                />
                <label :for="item.id">
                  <img :src="getImage(item.icon)" />
                  <span>{{ item.name[lang] }}</span>
                  <a
                    style="z-index: 110"
                    class="more"
                    data-toggle="modal"
                    data-target="#moreinfo"
                    @click="openModal(item)"
                    >{{ translate[lang]["moreinfo"] }}
                  </a>
                </label>
              </div>
            </div>
          </div>
          <!-- list of products -->

          <div v-if="data.type === 'suppliers' && data.group != 'insurance'">
            <div
              v-if="
                data.group === 'mobile' ||
                  data.group === 'internet' ||
                  data.group === 'bankaccount'
              "
            >
              <Providers :group="data.group"></Providers>
            </div>
            <div
              v-if="
                combinations[data.group] &&
                  (combinations[data.group].supplierCheck === 0 ||
                    (combinations[data.group].supplierCheck === 1 &&
                      postcodeQuery &&
                      itemsIsShow &&
                      itemsIsShow.filter(a => a.id == data.groupDefault)[0] &&
                      itemsIsShow.filter(a => a.id == data.groupDefault)[0]
                        .isShow))
              "
            >
              <Subscription
                :data="
                  filterOverview(data.product).widgets.filter(
                    x =>
                      x.type === 'subscription' &&
                      x.supplier_id === defaultSupplier(data.group).supplier_id
                  )
                "
                :group="data.group"
                v-if="
                  filterOverview(data.product) &&
                    filterOverview(data.product).widgets.filter(
                      x =>
                        x.type === 'subscription' &&
                        x.supplier_id ===
                          defaultSupplier(data.group).supplier_id
                    ).length > 0
                "
              ></Subscription>
              <SuppliersWidget
                :index="index"
                :section-group="data.group"
                :section-id="data.id"
                :section-type="data.type"
                :default-item="data.default"
                v-if="filterOverview(data.product)"
              ></SuppliersWidget>
              <Extras
                :data="
                  filterOverview(data.product).widgets.filter(
                    x =>
                      x.type === 'widget' &&
                      x.supplier_id === defaultSupplier(data.group).supplier_id
                  )
                "
                v-if="
                  filterOverview(data.product) &&
                    filterOverview(data.product).widgets.filter(
                      x =>
                        x.type === 'widget' &&
                        x.supplier_id ===
                          defaultSupplier(data.group).supplier_id
                    ).length > 0
                "
                :product="data.product"
                :group="data.group"
              ></Extras>
            </div>
          </div>
          <div v-if="data.type === 'suppliers' && data.group == 'insurance'">
            <NewSupplierWidget
              :index="index"
              :section-group="data.group"
              :section-id="data.id"
              :section-type="data.type"
              :default-item="data.default"
              v-if="filterOverview(data.product)"
            ></NewSupplierWidget>
          </div>
          <div v-if="data.type === 'datewidget'">
            <DateWidget></DateWidget>
          </div>
          <div v-if="data.type === 'familySituation' && this.form.data.action">
            <FamilySituation></FamilySituation>
          </div>
          <div v-if="data.type === 'insuranceForLead'">
            <InsuranceForLead></InsuranceForLead>
          </div>
          <div v-if="data.type === 'cityheat'">
            <Cityheat></Cityheat>
          </div>
          <div v-if="data.type === 'water'">
            <Water></Water>
          </div>
          <div v-if="data.type === 'commentWidget'">
            <Comment
              :comment="data.comment"
              :fromGroup="data.fromGroup"
              :id="data.id"
              :from="'preview'"
            ></Comment>
          </div>
          <div
            v-if="
              data.type === 'duration' &&
                combinations[data.group] &&
                (combinations[data.group].supplierCheck === 0 ||
                  (combinations[data.group].supplierCheck && postcodeQuery))
            "
          >
            <DurationWidget
              :index="index"
              :group="data.group"
              :product="data.product"
            ></DurationWidget>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.group === 'customerwidget'">
      <CustomerWidget :open="openModal"></CustomerWidget>
    </div>
    <div class="block" v-if="data.type === 'detailedoffer'">   
      <div class="block-header block-header-default">
        <h3 class="block-title">
          {{ translate[lang]["customizetitle"] }}
        </h3>
      </div>
      <div class="block-content">
        <Meter v-if="selectedProducts.includes(1)"></Meter>
        <Consumption></Consumption>
        <Solar v-if="selectedProducts.includes(1)"></Solar>
        <RateSelection v-if="smartMeter == 1"></RateSelection>
      </div>
    </div>
    <RatesTable
      v-if="
        consumption.electric.net <= 10000 &&
        data.type === 'customizedoffer' &&
          selectedProducts.length > 0 &&
          (selectedProducts.includes(1) || selectedProducts.includes(2))
      "
    ></RatesTable>
    <div class="alert alert-danger mt-2" role="alert" v-else-if="consumption.electric.net > 10000 && data.type === 'customizedoffer'">
      Helaas valt het door jou opgegeven geschatte verbruik buiten onze normale processen. We hebben wat meer informatie nodig van je en vragen je daarom contact met ons op te nemen. Na jouw bericht aan ons nemen we binnen 24 uur contact op zodat we je een passend energie voorstel kunnen doen.
    </div>
  </div> 
</template>

<script>
import WidgetComponent from "../../components/shared/WidgetComponent";
import DateWidget from "../widgets/DateWidget";
import DurationWidget from "../widgets/DurationWidget";
import CustomerWidget from "../../components/widgets/CustomerWidget";
import SuppliersWidget from "../widgets/SuppliersWidget";
import Providers from "../widgets/Providers";
import {mapMutations, mapState} from "vuex";
import Subscription from "../widgets/Subscription";
import Extras from "../widgets/Extras";
import RatesTable from "../../components/widgets/RatesTable";
import Consumption from "../../components/widgets/Consumption";
import Solar from "../../components/widgets/Solar";
import Meter from "../../components/widgets/Meter";
import RateSelection from "../../components/widgets/RateSelection";
import Cityheat from "../../components/widgets/Cityheat";
import Water from "../../components/widgets/Water";
import FamilySituation from "../../components/widgets/FamilySituation";
import InsuranceForLead from "../../components/widgets/InsuranceForLead";
import _ from "lodash";
import NewSupplierWidget from "../widgets/NewSupplierWidget.vue";
import Comment from "../widgets/Comment";
export default {
  name: "PreviewSection",
  components: {
    Extras,
    Subscription,
    WidgetComponent,
    DateWidget,
    DurationWidget,
    SuppliersWidget,
    Providers,
    CustomerWidget,
    RatesTable,
    Consumption,
    Solar,
    Meter,
    FamilySituation,
    InsuranceForLead,
    NewSupplierWidget,
    Cityheat,
    Water,
    Comment,
    RateSelection
  },
  props: ["data", "index"],
  data() {
    return {
      adressShow: 0,
      model: null,
      removeProducts: []
    };
  },
  computed: {
    ...mapState({
      combinations: state => state.forms.combinations,
      submitData: state => state.forms.SubmitData,
      itemsIsShow: state => state.forms.itemIsShow,
      ratesloader: state => state.forms.ratesloader,
      consumption: state => state.forms.consumption,
      meter: state => state.forms.meter,
      smartMeter: state => state.forms.smartMeter,
      form: (state) => state.forms.formStateData,
    }),
    _() {
      return _;
    }
  },
  mounted() {
    if(this.$route.query.removeProducts) {
      this.removeProducts = this.$route.query.removeProducts.split(',').map( Number );
    }

  },
  methods: {

    ...mapMutations({
      setEnergyTotal: "forms/SET_ENERGY_TOTAL",
      setGasTotal: "forms/SET_GAS_TOTAL",
    }),

    isDisabled(item) {

      if(this.ratesloader ||
          (item.id == 2 && !this.selectedProducts.includes(1))
      ) {
        return true
      }

    },

    selectProduct(e, data, parentData) {

      if (
        document.getElementsByClassName("product" + data) &&
        data !== undefined
      ) {
        if (e.target.checked) {
          parentData.defaultProducts.push(data);
        } else {
          this.removeProduct(data, parentData);
          if(data == 1) {
            this.removeProduct(2, parentData);
          }
          // set elektricity value to 0 - we calculate with this
          if(data == 1) {
            this.setEnergyTotal(0)
          }
          if(data == 2) {
            this.setGasTotal(0)
          }
        }
      }
    },
    openModal(item) {
      this.$emit("modal", {
        title: item.name[this.lang],
        description: item.description[this.lang]
      });
    }
  }
};
</script>

<style>
.hidden {
  display: none;
}
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}

.utility input {
  position: absolute;
  left: -9999px;
}

.utility label {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0; /* #f5fbfd */
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 170px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.utility label::before {
  content: "";
  display: block;
  position: absolute;
  top: 10px;
  right: 10px;
  width: 25px;
  height: 25px;
  border: 1px solid #a0a0a0;
  border-radius: 5px;
}

.utility label:hover,
input:focus + label {
  box-shadow: 0 0 5px #ffa400;
}

.utility input:checked + label {
  box-shadow: 0 0 3px 2px #ffa400;
}

.utility input:checked + label::before {
  background-color: #ffa400;
  content: "\2713";
  color: white;
}

.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}

.need-help {
  background-color: #ffe7c5;
  padding: 15px 20px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.need-help img {
  position: absolute;
  bottom: 0;
  max-width: 160px;
  right: -20px;
}

.disabledSupplier {
  opacity: 0.6;
}

.disabledProductsSelect {
  opacity: 0.4;
}
</style>
